import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions, routes } from '../actions/search';

import SearchTextField from '../components/features/SearchTextField';

import { getSearchQueryText } from '../reducers/search/queryText';
import {
  getLocationQuery,
  getLocationType,
} from '../reducers/location';
import { ROUTE_SEARCH } from '../routes/types';

class SearchTextFieldContainer extends React.PureComponent {
  static propTypes = {
    routeSearchQueryText: PropTypes.func.isRequired,
    setSearchQueryText: PropTypes.func.isRequired,
    searchQueryText: PropTypes.string,
  };

  static defaultProps = {
    searchQueryText: '',
  };

  handleChangeSearch = (e) => {
    this.props.setSearchQueryText(e.target.value);
  };

  handleSearch = (e, searchQueryText) => {
    this.props.routeSearchQueryText(searchQueryText, this.props.locationQuery);
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const {
      searchQueryText,
      routeSearchQueryText,
      setSearchQueryText,
      locationType,
      ...rest
    } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <SearchTextField
          value={searchQueryText}
          onChange={this.handleChangeSearch}
          onSearch={this.handleSearch}
          focused={locationType.indexOf(ROUTE_SEARCH) === 0}
          {...rest}
        />
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locationQuery: getLocationQuery(state),
  locationType: getLocationType(state),
  searchQueryText: getSearchQueryText(state),
  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setSearchQueryText: actions.setSearchQueryText,
  routeSearchQueryText: routes.routeSearchQueryText,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchTextFieldContainer);



// WEBPACK FOOTER //
// ./src/containers/SearchTextFieldContainer.js